<template>
	<div>
		<egranty-section-divider
			text="Geograficzny podział środków"
			icon="public"
		></egranty-section-divider>
		<div>
			<v-flex sm5 ml-3 py-3>
				<v-layout
					align-baseline=true
					row
					:key='index'
					v-for="(val,index) in data.countriesFundings"
				>
					<v-flex sm5>
						<strong>{{currentNames[index]}}</strong>
					</v-flex>
					<v-slider
						:disabled="readonly"
						v-if="data.countriesFundings[1] !== undefined"
						v-model='data.countriesFundings[index].value'
						:max=100
						@input="edit(index)"
					></v-slider>
					<input
						:disabled="readonly"
						type="number"
						value="value"
						v-model="val.value"
						v-if="data.countriesFundings[1] !== undefined"
						:min="0"
						:max="100"
						@input="editText(index)"
						style="text-align:right"
					/>
					<p v-if="data.countriesFundings[1] !== undefined" class="mb-0">%</p>
					<p v-if="data.countriesFundings[1] === undefined" class="mb-0" style="width:100px">100 % </p>
					<div v-if="!readonly && data.countriesFundings.length > 1">
						<v-icon @click="increment(index)" flat >
							add
						</v-icon>
						<v-icon @click="decrement(index)" flat>
							remove
						</v-icon>
					</div>

				</v-layout>
			</v-flex>
		</div>
	</div>
</template>

<script>
	import {AgencyTaskAccreditationCountry} from "@/api/generated/AgencyTaskAccreditationCountry";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "AgencyChooseFunding",
		components: {EgrantySectionDivider},
		methods: {

			increment(index) {
				this.data.countriesFundings[index].value++;
				this.editText(index);
			},

			decrement(index) {
				this.data.countriesFundings[index].value--;
				this.editText(index);
			},


			edit(index) {
				let last = this.data.countriesFundings.length - 1;
				let fundings = this.data.countriesFundings;

				//wartość, o którą musimy zmienić sumę sliderów
				let excess = -100;
				for (var i = 0; i < fundings.length; i++) {
					excess += fundings[i].value;
				}


				for (i = last; i >= 0; i--) {
					//nie ruszamy wartości slidera, który jest aktualnie edytowany
					if (i === index) {
						continue;
					}
					let change = Math.min(fundings[i].value, excess);
					fundings[i].value -= change;
					excess -= change;
				}

				this.$emit("input", this.data);
			},

			editText(index) {
				let last = this.data.countriesFundings.length - 1;
				if (this.data.countriesFundings[index].value === "" || isNaN(this.data.countriesFundings[index].value)) {
					this.data.countriesFundings[index].value = 0;
				} else {
					this.data.countriesFundings[index].value = parseInt(this.data.countriesFundings[index].value, 10);
					if (this.data.countriesFundings[index].value > 100) {
						this.data.countriesFundings[index].value = 100;
					}
				}
				let fundings = this.data.countriesFundings;

				//wartość, o którą musimy zmienić sumę sliderów
				let excess = -100;
				for (var i = 0; i < fundings.length; i++) {
					excess += fundings[i].value;
				}


				for (i = last; i >= 0; i--) {
					//nie ruszamy wartości slidera, który jest aktualnie edytowany
					if (i === index) {
						continue;
					}
					let change = Math.min(fundings[i].value, excess);
					fundings[i].value -= change;
					excess -= change;
				}
				this.$emit("input", this.data);
			},


			getOfferId() {
				return this.$route.params.offerId;
			},

			getContestId() {
				return this.$route.params.id;
			},

			refresh() {
				if (this.agencyId === undefined) {
					return;
				}
				AgencyTaskAccreditationCountry.getAvailableCountriesForAgency(
					this,
					this.getContestId(),
					this.agencyId,
					response => {
						this.countries = response;
						this.updateCurrentCountries();
					},
				);

			},

			findCountryById(id) {
				var country = this.countries.find(x => x.id === id);
				if (country === undefined) {
					return undefined;
				}
				return country.name;
			},

			updateCurrentCountries() {
				this.currentNames = [];
				for (let i = 0; i < this.data.countriesFundings.length; i++) {
					this.currentNames.push(this.findCountryById(this.data.countriesFundings[i].id));
				}

			},
		},


		data() {
			return {
				countries: [],
				currentNames: [],
				data: {
					countriesFundings: [],
				},
				minFunding: 0,
				maxFunding: 0,
				fundingError: "",
			};
		}
		,

		watch: {

			value: {
				immediate: true,
				deep:
					true,
				handler(val) {
					if (val === undefined) {
						return;
					}
					this.data = val;
					if (this.countries.length === 0) {
						this.refresh();
					}
				},
			}
			,

			input: {
				immediate: true,
				deep:
					true,
				handler(val) {
					if (!this.countriesChanged) {
						this.updateCurrentCountries();
						return;
					}

					this.data.countriesFundings = [];
					this.currentNames = [];
					if (val.mainCountryId !== undefined) {
						this.data.countriesFundings.push({id: val.mainCountryId, value: 100});
						this.currentNames.push(this.findCountryById(val.mainCountryId));
					}
					for (var i = 0; i < val.extraCountries.length; i++) {
						for (i = 0; i < val.extraCountries.length; i++) {
							this.data.countriesFundings.push({id: val.extraCountries[i], value: 0});
							this.currentNames.push(this.findCountryById(val.extraCountries[i]));
						}
					}
					this.$emit("update:countriesChanged", false);
					this.$emit("input", this.data);
				},
			},
		}

		,

		mounted() {
			this.refresh();
		}
		,


		props: {
			readonly: {type: Boolean, default: false},
			input: {},
			value: {},
			countriesChanged: {},
			agencyId: Number,
		},
	};

</script>

<style scoped>
	.country-name {
		width: 180px;
		overflow-wrap: break-word;
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type=number] {
		-moz-appearance:textfield;
	}
</style>
